import {
  buildStrategyApprovalCompletionMessage,
  buildArtsApprovalCompletionMessage,
  buildCompletionModeMessage,
  buildBatchEditConfirmMessage,
  buildBatchRejectConfirmMessage,
  buildFinalActionCompletionMessage,
  STRATEGY_APPROVAL_OPTIONS,
  ARTS_APPROVAL_OPTIONS,
  COMPLETION_MODE_OPTIONS,
  BATCH_EDIT_CONFIRM_OPTIONS,
  BATCH_REJECT_CONFIRM_OPTIONS,
  FINAL_ACTION_OPTIONS,
  CAMPAIGN_WIDGET_TOOL_NAMES,
  mapBatchEditAction,
  mapBatchRejectAction,
  mapFinalAction,
  mapApprovalAction,
  mapCompletionModeAction,
} from './campaignCompletionMessages';

export const APPROVAL_VARIANTS = {
  strategy: {
    toolName: CAMPAIGN_WIDGET_TOOL_NAMES.APROVACAO_ESTRATEGIA,
    componentKey: 'strategyApproval',
    options: STRATEGY_APPROVAL_OPTIONS,
    mapAction: mapApprovalAction,
    buildMessage: buildStrategyApprovalCompletionMessage,
  },
  arts: {
    toolName: CAMPAIGN_WIDGET_TOOL_NAMES.APROVACAO_ARTES,
    componentKey: 'artsApproval',
    options: ARTS_APPROVAL_OPTIONS,
    mapAction: mapApprovalAction,
    buildMessage: buildArtsApprovalCompletionMessage,
  },
  completionMode: {
    toolName: CAMPAIGN_WIDGET_TOOL_NAMES.MODO_CONCLUSAO,
    componentKey: 'completionMode',
    options: COMPLETION_MODE_OPTIONS,
    mapAction: mapCompletionModeAction,
    buildMessage: buildCompletionModeMessage,
  },
  batchConfirm: {
    toolName: CAMPAIGN_WIDGET_TOOL_NAMES.CONFIRMAR_EDICAO_LOTE,
    componentKey: 'batchEditConfirm',
    options: BATCH_EDIT_CONFIRM_OPTIONS,
    mapAction: mapBatchEditAction,
    buildMessage: (action) =>
      buildBatchEditConfirmMessage(action === 'CONFIRM'),
  },
  batchRejectConfirm: {
    toolName: CAMPAIGN_WIDGET_TOOL_NAMES.CONFIRMAR_REJEICAO_LOTE,
    componentKey: 'batchRejectConfirm',
    options: BATCH_REJECT_CONFIRM_OPTIONS,
    mapAction: mapBatchRejectAction,
    buildMessage: (action) =>
      buildBatchRejectConfirmMessage(action === 'CONFIRM'),
  },
  finalActions: {
    toolName: CAMPAIGN_WIDGET_TOOL_NAMES.ACOES_FINAIS,
    componentKey: 'completionActions',
    options: FINAL_ACTION_OPTIONS,
    mapAction: mapFinalAction,
    buildMessage: buildFinalActionCompletionMessage,
  },
};
